var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('AppNavBar',{directives:[{name:"show",rawName:"v-show",value:(_vm.user && _vm.user.id),expression:"user && user.id"}]}),_c('v-main',{staticClass:"pt-12"},[_c('router-view'),_c('notification')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }